import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Oauth2Service } from '../oauth2.service';
import { OAuth2Client, OAuth2ConsentSession } from '../../../sdk/hydra';
import { KeyValuePipe, NgClass } from '@angular/common';
import { UIDialog } from '@irohalab/deneb-ui';
import { OAuth2ClientDialogComponent } from './oauth2-client-dialog/oauth2-client-dialog.component';

type ClientConsentSessionDict = {
  [clientId: string]: {
    client: OAuth2Client;
    consentSessionList: OAuth2ConsentSession[];
  }
}

@Component({
    selector: 'app-oauth2-settings',
    imports: [
    KeyValuePipe,
    NgClass
],
    templateUrl: './oauth2-settings.component.html',
    styleUrl: './oauth2-settings.component.less'
})
export class OAuth2SettingsComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private pageToken!: string | undefined;

  clientSessionDict!: ClientConsentSessionDict;
  expandDict: {[key: string]: boolean} = {};

  constructor(private oAuth2Service: Oauth2Service,
              private dialogService: UIDialog) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.listSessions();
  }

  listSessions(): void {
    this.subscription.add(
      this.oAuth2Service.listConsentSessions(this.pageToken)
        .subscribe({
          next: (data) => {
            this.clientSessionDict = {};
            for (const session of data.data) {
              if (session.consent_request && session.consent_request.client && session.consent_request.client.client_id) {
                const client = session.consent_request.client;
                if (!this.clientSessionDict[String(client.client_id)]) {
                  this.clientSessionDict[String(client.client_id)] = {
                    client,
                    consentSessionList: []
                  };
                }
                delete session.consent_request.client;
                this.clientSessionDict[String(client.client_id)].consentSessionList.push(session);
              }
            }
            this.pageToken = data.next;
          },
          error: (err) => {
            console.log(err);
          }
        })
    );
  }

  viewClient(client?: OAuth2Client): void {
    if (client) {
      const dialogRef = this.dialogService.open(OAuth2ClientDialogComponent, {stickyDialog: false, backdrop: true});
      dialogRef.componentInstance.client = client;
      dialogRef.afterClosed().subscribe(result => {})
    }
  }

  toggle(key: string): void {
    this.expandDict[key] = !this.expandDict[key];
    // console.log(this.expandDict);
  }

  logoutSession(session: OAuth2ConsentSession): void {
    if (session.consent_request?.login_session_id) {
      this.subscription.add(
        this.oAuth2Service.RevokeSession(session.consent_request?.login_session_id)
          .subscribe({
            next: () => {
              this.listSessions();
            },
            error: (err) => {}
          })
      );
    }
  }

  revokeClient(clientId?: string): void {
    if (clientId) {
      this.subscription.add(
        this.oAuth2Service.RevokeClientConsent(clientId).subscribe({
          next: () => {
            this.listSessions();
          },
          error: (err) => {}
        })
      );
    }
  }
}
